import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValidatorFn, AbstractControl, FormBuilder, FormGroup, Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-add-guard',
  templateUrl: './add-guard.component.html',
  styleUrls: ['./add-guard.component.css']
})
export class AddGuardComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) {}
  positions: { id: number; name: string }[] = [];
  ngOnInit(): void {
    this.api.getGuardPositions().subscribe((res) => (this.positions = (res.data as any[]) ?? []), () => (this.positions = []));
  }
  @Output()
  success = new EventEmitter<boolean>();
  form1 = new UntypedFormGroup({
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(''),
    rut: new UntypedFormControl('',[Validators.required,MyValidators.rut]),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
    os10:new UntypedFormControl('si'),
    position_id: new UntypedFormControl(''),
  });

  create() {
    this.api.createGuards(this.form1).subscribe(
      (res) => {
        this.toast.success(res.msg, 'Registro de guardia');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg,{enableHtml:true,closeButton:true});
      }
    );
  }
  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
